export enum EmailType {
  Confirmation = 'Confirmation',
  Invitation = 'Invitation',
  PasswordReset = 'PasswordReset',
  EmailChanged = 'EmailChanged',
  PasswordChanged = 'PasswordChanged',
  AppleConsentRevoked = 'AppleConsentRevoked',
  AccessReenabled = 'AccessReenabled',
}
